var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.emptyLoaderShow)?_c('div',{staticClass:"pre-holder-page"},[_c('div',{staticClass:"pre-holder-panel"},_vm._l((15),function(index){return _c('div',{key:index,class:'holder-item '+(index==3?'big':'')})}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5681f347","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/predataholder.vue
// module id = null
// module chunks = 